module.exports = __webpack_public_path__ + "static/media/hdi-headset.9887a79c.svg";